import React, { useState } from 'react';

// 🔑 ADD YOUR ANTHROPIC API KEY HERE
const ANTHROPIC_API_KEY =
  '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';

const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&family=Nunito+Sans:wght@400;600;700&display=swap');`;

const css = `
    ${FONTS}
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --bg: #f0f2f5; --surface: #ffffff; --navy: #0d1b2a; --navy2: #1a2e45;
      --cyan: #00c2d4; --cyan-dim: rgba(0,194,212,0.12); --cyan-glow: rgba(0,194,212,0.25);
      --green: #00b37d; --yellow: #e8a020; --red: #d64045;
      --border: #e2e6eb; --border-dark: #c8cdd5;
      --text: #0d1b2a; --text-dim: #4a5568; --text-muted: #8a9ab0;
      --font-display: 'Rajdhani', sans-serif;
      --font-mono: 'JetBrains Mono', monospace;
      --font-body: 'Nunito Sans', sans-serif;
    }
    body { background: var(--bg); color: var(--text); font-family: var(--font-body); min-height: 100vh; }
    .app { max-width: 1080px; margin: 0 auto; padding: 36px 24px 80px; }
  
    /* GATE */
    .gate-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: var(--navy); padding: 24px; position: relative; overflow: hidden; }
    .gate-wrap::before { content: ''; position: absolute; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(0,194,212,0.06) 0%, transparent 70%); top: -200px; right: -200px; pointer-events: none; }
    .gate-card { background: #111a26; border: 1px solid #1e2d40; border-top: 2px solid var(--cyan); border-radius: 10px; padding: 44px 40px; width: 100%; max-width: 460px; animation: gateIn 0.5s cubic-bezier(0.4,0,0.2,1) forwards; }
    @keyframes gateIn { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
    .gate-logo { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.2em; text-transform: uppercase; color: var(--cyan); margin-bottom: 28px; display: flex; align-items: center; gap: 8px; }
    .gate-logo::before { content: ''; width: 20px; height: 2px; background: var(--cyan); }
    .gate-title { font-family: var(--font-display); font-size: 28px; font-weight: 700; color: #fff; line-height: 1.15; margin-bottom: 8px; }
    .gate-title span { color: var(--cyan); }
    .gate-sub { font-size: 13px; color: #4a6070; line-height: 1.6; margin-bottom: 32px; }
    .gate-fields { display: flex; flex-direction: column; gap: 14px; }
    .gate-field { display: flex; flex-direction: column; gap: 5px; }
    .gate-label { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.15em; text-transform: uppercase; color: #3a5a70; }
    .gate-input { background: #0d1b2a; border: 1px solid #1e2d40; border-radius: 4px; padding: 11px 14px; font-family: var(--font-body); font-size: 14px; color: #c8dae8; outline: none; transition: border-color 0.15s, box-shadow 0.15s; width: 100%; }
    .gate-input:focus { border-color: var(--cyan); box-shadow: 0 0 0 3px rgba(0,194,212,0.1); }
    .gate-input::placeholder { color: #2a3d50; }
    .gate-error { font-family: var(--font-mono); font-size: 9px; color: var(--red); margin-top: 3px; }
    .gate-submit { margin-top: 24px; width: 100%; padding: 14px; background: var(--cyan); color: var(--navy); font-family: var(--font-display); font-size: 14px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; border-radius: 5px; cursor: pointer; transition: all 0.15s; }
    .gate-submit:hover:not(:disabled) { background: #00d9ed; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(0,194,212,0.25); }
    .gate-submit:disabled { opacity: 0.3; cursor: not-allowed; }
    .gate-footer { margin-top: 20px; font-family: var(--font-mono); font-size: 9px; color: #1e2d40; text-align: center; letter-spacing: 0.1em; text-transform: uppercase; }
  
    /* WELCOME */
    .welcome-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: var(--navy); padding: 24px; }
    .welcome-card { text-align: center; max-width: 520px; animation: welcomeIn 0.6s cubic-bezier(0.4,0,0.2,1) forwards; }
    @keyframes welcomeIn { from{opacity:0;transform:scale(0.95)} to{opacity:1;transform:scale(1)} }
    .welcome-icon { width: 64px; height: 64px; border-radius: 50%; background: rgba(0,194,212,0.12); border: 1px solid rgba(0,194,212,0.3); display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; font-size: 28px; }
    .welcome-greeting { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.2em; text-transform: uppercase; color: var(--cyan); margin-bottom: 12px; }
    .welcome-title { font-family: var(--font-display); font-size: 34px; font-weight: 700; color: #fff; line-height: 1.2; margin-bottom: 16px; }
    .welcome-body { font-size: 14px; color: #4a6070; line-height: 1.7; margin-bottom: 36px; }
    .welcome-body strong { color: #7a9ab0; }
    .welcome-stats { display: flex; justify-content: center; gap: 32px; margin-bottom: 36px; }
    .wstat { display: flex; flex-direction: column; gap: 4px; }
    .wstat-val { font-family: var(--font-display); font-size: 22px; font-weight: 700; color: var(--cyan); }
    .wstat-label { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.12em; text-transform: uppercase; color: #2a3d50; }
    .welcome-btn { padding: 14px 40px; background: var(--cyan); color: var(--navy); font-family: var(--font-display); font-size: 14px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; border-radius: 5px; cursor: pointer; transition: all 0.15s; }
    .welcome-btn:hover { background: #00d9ed; transform: translateY(-1px); box-shadow: 0 6px 24px rgba(0,194,212,0.3); }
  
    /* HEADER */
    .header { background: var(--navy); border-radius: 10px; padding: 32px 36px; margin-bottom: 20px; position: relative; overflow: hidden; }
    .header::before { content: ''; position: absolute; top: 0; right: 0; width: 300px; height: 100%; background: linear-gradient(135deg, transparent 40%, rgba(0,194,212,0.08)); pointer-events: none; }
    .header::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, var(--cyan), transparent 60%); }
    .header-eyebrow { font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.2em; text-transform: uppercase; color: var(--cyan); margin-bottom: 8px; }
    .header-title { font-family: var(--font-display); font-size: clamp(26px,4vw,42px); font-weight: 700; color: #fff; letter-spacing: 0.02em; line-height: 1.1; margin-bottom: 8px; }
    .header-title span { color: var(--cyan); }
    .header-sub { font-size: 13px; color: #7a8fa8; max-width: 560px; line-height: 1.6; }
    .header-meta { position: absolute; right: 36px; top: 32px; text-align: right; }
    .header-meta-tag { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.15em; color: #3a5068; text-transform: uppercase; line-height: 2; }
  
    /* STEPS */
    .steps-bar { display: flex; gap: 2px; margin-bottom: 20px; }
    .step-item { flex: 1; background: var(--surface); border: 1px solid var(--border); padding: 12px 16px; border-radius: 4px; cursor: pointer; transition: all 0.15s; display: flex; align-items: center; gap: 10px; }
    .step-item.active { border-color: var(--cyan); background: var(--cyan-dim); }
    .step-item.done { border-color: var(--green); }
    .step-num { width: 22px; height: 22px; border-radius: 50%; background: var(--bg); border: 1.5px solid var(--border-dark); font-family: var(--font-mono); font-size: 10px; display: flex; align-items: center; justify-content: center; color: var(--text-muted); flex-shrink: 0; }
    .step-item.active .step-num { border-color: var(--cyan); color: var(--cyan); background: var(--cyan-dim); }
    .step-item.done .step-num { border-color: var(--green); color: var(--green); background: rgba(0,179,125,0.1); }
    .step-label { font-size: 11px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--text-muted); }
    .step-item.active .step-label { color: var(--cyan); }
    .step-item.done .step-label { color: var(--green); }
  
    /* CARD */
    .card { background: var(--surface); border: 1px solid var(--border); border-radius: 8px; padding: 28px; margin-bottom: 16px; }
    .card-title { font-family: var(--font-display); font-size: 16px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--navy); margin-bottom: 20px; display: flex; align-items: center; gap: 10px; }
    .card-title::after { content: ''; flex: 1; height: 1px; background: var(--border); }
    .context-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; }
    @media(max-width:640px){ .context-grid { grid-template-columns: 1fr 1fr; } }
    .field { display: flex; flex-direction: column; gap: 5px; }
    .field-label { font-size: 10px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: var(--text-muted); }
    .field-input { background: var(--bg); border: 1px solid var(--border-dark); border-radius: 4px; padding: 9px 12px; font-family: var(--font-mono); font-size: 13px; color: var(--text); outline: none; transition: border-color 0.15s, box-shadow 0.15s; -webkit-appearance: none; cursor: pointer; }
    .field-input:focus { border-color: var(--cyan); box-shadow: 0 0 0 3px var(--cyan-dim); }
  
    /* PIPELINE */
    .pipeline { display: flex; align-items: stretch; gap: 0; overflow-x: auto; padding-bottom: 4px; margin-bottom: 24px; }
    .pipe-node { flex: 1; min-width: 100px; position: relative; cursor: pointer; }
    .pipe-node-inner { border: 2px solid var(--border-dark); padding: 14px 10px; text-align: center; transition: all 0.15s; background: var(--bg); height: 100%; position: relative; }
    .pipe-node:first-child .pipe-node-inner { border-radius: 6px 0 0 6px; }
    .pipe-node:last-child .pipe-node-inner { border-radius: 0 6px 6px 0; }
    .pipe-node:not(:first-child) .pipe-node-inner { border-left: none; }
    .pipe-node.selected .pipe-node-inner { border-color: var(--cyan); border-left: 2px solid var(--cyan) !important; background: var(--cyan-dim); z-index: 1; }
    .pipe-node.level-none .pipe-node-inner { border-top: 3px solid var(--red); }
    .pipe-node.level-partial .pipe-node-inner { border-top: 3px solid var(--yellow); }
    .pipe-node.level-full .pipe-node-inner { border-top: 3px solid var(--green); }
    .pipe-icon { font-size: 20px; margin-bottom: 4px; }
    .pipe-name { font-family: var(--font-display); font-size: 11px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; color: var(--navy); }
    .pipe-status { font-family: var(--font-mono); font-size: 8px; margin-top: 4px; letter-spacing: 0.08em; text-transform: uppercase; }
    .pipe-status.none { color: var(--red); } .pipe-status.partial { color: var(--yellow); } .pipe-status.full { color: var(--green); }
    .pipe-arrow { position: absolute; right: -10px; top: 50%; transform: translateY(-50%); width: 0; height: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-left: 10px solid var(--border-dark); z-index: 2; }
    .pipe-node:last-child .pipe-arrow { display: none; }
    .process-config { background: var(--bg); border: 1px solid var(--border); border-left: 3px solid var(--cyan); border-radius: 0 6px 6px 0; padding: 20px; animation: fadeIn 0.2s ease; }
    @keyframes fadeIn { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:translateY(0)} }
    .config-title { font-family: var(--font-display); font-size: 15px; font-weight: 700; color: var(--navy); margin-bottom: 16px; letter-spacing: 0.04em; text-transform: uppercase; }
    .config-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; }
    @media(max-width:640px){ .config-grid { grid-template-columns: 1fr 1fr; } }
    .level-sel { display: flex; gap: 3px; }
    .lev-btn { flex: 1; padding: 7px 4px; border: 1px solid var(--border-dark); background: var(--surface); font-family: var(--font-body); font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; cursor: pointer; color: var(--text-muted); transition: all 0.12s; border-radius: 3px; }
    .lev-btn.none.active { background: rgba(214,64,69,0.1); border-color: var(--red); color: var(--red); }
    .lev-btn.partial.active { background: rgba(232,160,32,0.1); border-color: var(--yellow); color: var(--yellow); }
    .lev-btn.full.active { background: rgba(0,179,125,0.1); border-color: var(--green); color: var(--green); }
    .pain-track { display: flex; flex-direction: column; gap: 4px; }
    .pain-val { font-family: var(--font-mono); font-size: 18px; font-weight: 500; color: var(--navy); }
    input[type=range] { -webkit-appearance: none; width: 100%; height: 3px; background: var(--border-dark); border-radius: 2px; outline: none; cursor: pointer; }
    input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; width: 14px; height: 14px; border-radius: 50%; background: var(--cyan); border: 2px solid var(--surface); box-shadow: 0 0 6px var(--cyan-glow); }
    .legend { display: flex; gap: 16px; margin-top: 12px; }
    .leg-item { display: flex; align-items: center; gap: 5px; font-size: 10px; color: var(--text-muted); }
    .leg-dot { width: 8px; height: 8px; border-radius: 2px; }
  
    /* BUTTONS */
    .cta-row { display: flex; gap: 10px; margin-top: 20px; }
    .btn-primary { flex: 1; padding: 14px 20px; background: var(--navy); color: #fff; font-family: var(--font-display); font-size: 14px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; border-radius: 5px; cursor: pointer; transition: all 0.15s; position: relative; overflow: hidden; }
    .btn-primary::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: var(--cyan); }
    .btn-primary:hover:not(:disabled) { background: var(--navy2); transform: translateY(-1px); box-shadow: 0 6px 20px rgba(13,27,42,0.3); }
    .btn-primary:disabled { opacity: 0.4; cursor: not-allowed; }
    .btn-secondary { padding: 14px 20px; background: transparent; color: var(--text-dim); font-family: var(--font-body); font-size: 12px; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; border: 1px solid var(--border-dark); border-radius: 5px; cursor: pointer; transition: all 0.12s; }
    .btn-secondary:hover { border-color: var(--cyan); color: var(--cyan); }
  
    /* RESULTS */
    .results-header { display: grid; grid-template-columns: repeat(4,1fr); gap: 2px; margin-bottom: 16px; }
    @media(max-width:640px){ .results-header { grid-template-columns: 1fr 1fr; gap: 8px; } }
    .metric-tile { background: var(--navy); border-radius: 5px; padding: 18px 16px; position: relative; overflow: hidden; }
    .metric-tile::before { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: var(--color, var(--cyan)); transform: scaleX(var(--fill, 0.7)); transform-origin: left; transition: transform 1.2s cubic-bezier(0.4,0,0.2,1); }
    .metric-key { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.15em; text-transform: uppercase; color: #3a5068; margin-bottom: 6px; }
    .metric-val { font-family: var(--font-display); font-size: 28px; font-weight: 700; color: var(--color, var(--cyan)); line-height: 1; }
    .metric-sub { font-size: 10px; color: #4a6070; margin-top: 3px; }
    .roadmap { display: flex; gap: 2px; margin-bottom: 16px; }
    @media(max-width:640px){ .roadmap { flex-direction: column; } }
    .phase-card { flex: 1; border: 1px solid var(--border); border-radius: 5px; padding: 18px; background: var(--surface); animation: slideUp 0.4s ease forwards; opacity: 0; }
    .phase-card:nth-child(1){animation-delay:0.1s} .phase-card:nth-child(2){animation-delay:0.22s} .phase-card:nth-child(3){animation-delay:0.34s}
    @keyframes slideUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
    .phase-tag { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.15em; text-transform: uppercase; margin-bottom: 6px; display: inline-block; padding: 2px 8px; border-radius: 2px; background: var(--phase-bg); color: var(--phase-color); }
    .phase-title { font-family: var(--font-display); font-size: 14px; font-weight: 700; color: var(--navy); margin-bottom: 6px; }
    .phase-timeline { font-family: var(--font-mono); font-size: 10px; color: var(--text-muted); margin-bottom: 10px; }
    .phase-items { display: flex; flex-direction: column; gap: 5px; }
    .phase-item { font-size: 11px; color: var(--text-dim); display: flex; gap: 6px; line-height: 1.4; }
    .phase-item::before { content: '→'; color: var(--phase-color); flex-shrink: 0; font-family: var(--font-mono); font-size: 10px; margin-top: 1px; }
    .gap-table { width: 100%; border-collapse: collapse; }
    .gap-table th { font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--text-muted); padding: 8px 12px; text-align: left; border-bottom: 1px solid var(--border); background: var(--bg); }
    .gap-table td { font-size: 12px; color: var(--text-dim); padding: 10px 12px; border-bottom: 1px solid var(--border); vertical-align: top; }
    .gap-table tr:last-child td { border-bottom: none; }
    .gap-table tr:hover td { background: var(--bg); }
    .proc-name { font-weight: 700; color: var(--navy); font-size: 12px; display: flex; align-items: center; gap: 6px; }
    .gap-badge { display: inline-block; padding: 2px 6px; border-radius: 2px; font-family: var(--font-mono); font-size: 8px; letter-spacing: 0.08em; text-transform: uppercase; font-weight: 500; }
    .gap-high { background: rgba(214,64,69,0.1); color: var(--red); }
    .gap-med { background: rgba(232,160,32,0.1); color: var(--yellow); }
    .gap-low { background: rgba(0,179,125,0.1); color: var(--green); }
    .tech-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 10px; }
    @media(max-width:640px){ .tech-grid { grid-template-columns: 1fr 1fr; } }
    .tech-chip { border: 1px solid var(--border); border-radius: 4px; padding: 10px 12px; background: var(--bg); animation: fadeIn 0.3s ease forwards; opacity: 0; }
    .tech-cat { font-family: var(--font-mono); font-size: 7px; letter-spacing: 0.15em; text-transform: uppercase; color: var(--cyan); margin-bottom: 3px; }
    .tech-name { font-size: 12px; font-weight: 700; color: var(--navy); }
    .tech-note { font-size: 10px; color: var(--text-muted); margin-top: 2px; }
    .narrative { background: var(--navy); border-radius: 6px; padding: 20px 22px; margin-bottom: 14px; }
    .narrative p { font-size: 13px; color: #8aa0b8; line-height: 1.75; }
    .loading-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px 20px; gap: 20px; }
    .loading-pipeline { display: flex; align-items: center; gap: 6px; }
    .load-seg { height: 4px; width: 32px; border-radius: 2px; background: var(--border-dark); animation: fillBar 1.8s ease infinite; }
    .load-seg:nth-child(1){animation-delay:0s} .load-seg:nth-child(2){animation-delay:0.15s} .load-seg:nth-child(3){animation-delay:0.3s} .load-seg:nth-child(4){animation-delay:0.45s} .load-seg:nth-child(5){animation-delay:0.6s} .load-seg:nth-child(6){animation-delay:0.75s} .load-seg:nth-child(7){animation-delay:0.9s}
    @keyframes fillBar { 0%,100%{background:var(--border-dark)} 50%{background:var(--cyan)} }
    .load-text { font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.12em; color: var(--text-muted); text-transform: uppercase; }
    .footer { margin-top: 48px; padding-top: 20px; border-top: 1px solid var(--border); display: flex; justify-content: space-between; }
    .footer-l { font-family: var(--font-mono); font-size: 9px; color: var(--text-muted); letter-spacing: 0.1em; text-transform: uppercase; }
  `;

const PROCESSES = [
  {
    id: 'inbound',
    icon: '📦',
    name: 'Inbound',
    desc: 'Receiving, unloading, dock management',
  },
  {
    id: 'putaway',
    icon: '🏗️',
    name: 'Put-Away',
    desc: 'Storage assignment, ASRS, racking',
  },
  {
    id: 'picking',
    icon: '🤖',
    name: 'Picking',
    desc: 'Order picking, goods-to-person, AMR',
  },
  {
    id: 'packing',
    icon: '📋',
    name: 'Packing',
    desc: 'Pack stations, void fill, labelling',
  },
  {
    id: 'sortation',
    icon: '↔️',
    name: 'Sortation',
    desc: 'Chute sorters, cross-belt, loop',
  },
  {
    id: 'shipping',
    icon: '🚚',
    name: 'Shipping',
    desc: 'Manifesting, carrier integration, dock scheduling',
  },
  {
    id: 'returns',
    icon: '🔄',
    name: 'Returns',
    desc: 'Reverse logistics, grading, re-stow',
  },
];
const VERTICALS = [
  'E-Commerce / Parcel',
  '3PL / Contract Logistics',
  'Retail / FMCG',
  'Food & Beverage',
  'Pharma / Healthcare',
  'Automotive',
];
const SCALES = [
  'Single site',
  '2–5 sites',
  '6–20 sites',
  '20–50 sites',
  '50+ sites (global)',
];
const VOLUMES = [
  '<5k parcels/day',
  '5k–20k',
  '20k–80k',
  '80k–250k',
  '>250k parcels/day',
];

function parseJSON(text) {
  try {
    const c = text.replace(/```json|```/g, '').trim();
    return JSON.parse(c.slice(c.indexOf('{'), c.lastIndexOf('}') + 1));
  } catch {
    return null;
  }
}

// ── MAIN APP ──────────────────────────────────────────────────────────────────
export default function App() {
  const [screen, setScreen] = useState('app');
  const [step, setStep] = useState(1);
  const [context, setContext] = useState({
    vertical: VERTICALS[0],
    scale: SCALES[2],
    volume: VOLUMES[2],
  });
  const [processes, setProcesses] = useState(
    Object.fromEntries(
      PROCESSES.map((p) => [p.id, { level: 'none', pain: 5, volume: 'medium' }])
    )
  );
  const [selected, setSelected] = useState('inbound');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const setCtx = (k, v) => setContext((c) => ({ ...c, [k]: v }));
  const setProc = (id, k, v) =>
    setProcesses((p) => ({ ...p, [id]: { ...p[id], [k]: v } }));
  const levelLabel = (l) =>
    l === 'none' ? 'Manual' : l === 'partial' ? 'Partial' : 'Automated';

  // ── SCREENS ────────────────────────────────────────────────────────────────

  // ── AI ANALYSIS ────────────────────────────────────────────────────────────
  const buildPrompt = () => {
    const procLines = PROCESSES.map((p) => {
      const cfg = processes[p.id];
      return `- ${p.name}: ${levelLabel(
        cfg.level
      )} automation, pain intensity ${cfg.pain}/10`;
    }).join('\n');
    return `You are an expert end-to-end logistics automation consultant.
  
  CLIENT PROFILE:
  - Vertical: ${context.vertical}
  - Scale: ${context.scale}
  - Daily volume: ${context.volume}
  
  CURRENT PROCESS AUTOMATION STATUS:
  ${procLines}
  
  Return ONLY valid JSON (no markdown, no text outside):
  
  {
    "e2eScore": <integer 0-100>,
    "integrationRisk": <"LOW"|"MEDIUM"|"HIGH">,
    "totalROIMonths": <integer>,
    "annualGainEUR": <integer>,
    "executiveSummary": "<2-3 sentences>",
    "processGaps": [
      { "process": "<name>", "gapLevel": "HIGH|MED|LOW", "gap": "<1 sentence>", "quickWin": "<technology>" }
    ],
    "phases": [
      { "phase": "Phase 1", "title": "<title>", "timeline": "<Months 0-6>", "focus": "<1 sentence>", "actions": ["<action>","<action>","<action>"] },
      { "phase": "Phase 2", "title": "<title>", "timeline": "<Months 6-18>", "focus": "<1 sentence>", "actions": ["<action>","<action>","<action>"] },
      { "phase": "Phase 3", "title": "<title>", "timeline": "<Months 18-36>", "focus": "<1 sentence>", "actions": ["<action>","<action>","<action>"] }
    ],
    "techStack": [
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" },
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" },
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" },
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" },
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" },
      { "category": "<cat>", "technology": "<product>", "rationale": "<10 words>" }
    ],
    "integrationNote": "<1-2 sentences>"
  }`;
  };

  const saveAssessment = async (ctx, procs, result) => {
    try {
      const processSnapshot = PROCESSES.map((p) => {
        const cfg = procs[p.id];
        return `${p.name}: ${cfg.level}, pain ${cfg.pain}/10, vol ${cfg.volume}`;
      }).join(' | ');
      await fetch('https://formspree.io/f/xykngage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          _subject: `Assessment: ${ctx.vertical} — ${ctx.scale}`,
          vertical: ctx.vertical,
          scale: ctx.scale,
          volume: ctx.volume,
          processInputs: processSnapshot,
          e2eScore: result.e2eScore,
          integrationRisk: result.integrationRisk,
          roiMonths: result.totalROIMonths,
          annualGainEUR: result.annualGainEUR,
          topHighGaps: (result.processGaps || [])
            .filter((g) => g.gapLevel === 'HIGH')
            .map((g) => g.process)
            .join(', '),
          executiveSummary: result.executiveSummary,
          submittedAt: new Date().toISOString(),
        }),
      });
    } catch (e) {
      console.warn('Save failed:', e);
    }
  };

  const runAnalysis = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ANTHROPIC_API_KEY,
          'anthropic-version': '2023-06-01',
          'anthropic-dangerous-direct-browser-access': 'true',
        },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 1500,
          messages: [{ role: 'user', content: buildPrompt() }],
        }),
      });
      const data = await res.json();
      const text = data.content?.map((b) => b.text || '').join('') || '';
      const parsed = parseJSON(text);
      if (!parsed) throw new Error('parse');
      setResult(parsed);
      setStep(3);
      await saveAssessment(context, processes, parsed);
    } catch (e) {
      setError('Analysis failed. Check your API key and try again.');
    } finally {
      setLoading(false);
    }
  };

  const exportBrief = () => {
    if (!result) return;
    const lines = [
      'E2E LOGISTICS AUTOMATION STRATEGY BRIEF',
      `Generated: ${new Date().toLocaleDateString('en-DE')}`,
      '',
      'OPERATION PROFILE',
      `Vertical: ${context.vertical} | Scale: ${context.scale} | Volume: ${context.volume}`,
      '',
      'KEY METRICS',
      `E2E Maturity Score: ${result.e2eScore}/100`,
      `Integration Risk: ${result.integrationRisk}`,
      `ROI Timeline: ${result.totalROIMonths} months`,
      `Annual Gain: €${result.annualGainEUR?.toLocaleString()}`,
      '',
      'EXECUTIVE SUMMARY',
      result.executiveSummary,
      '',
      'PROCESS GAPS',
      ...(result.processGaps || []).map(
        (g) =>
          `[${g.gapLevel}] ${g.process}: ${g.gap}\n  Quick Win: ${g.quickWin}`
      ),
      '',
      'ROADMAP',
      ...(result.phases || []).map(
        (p) =>
          `${p.phase} – ${p.title} (${p.timeline})\n${p.actions
            .map((a) => `  • ${a}`)
            .join('\n')}`
      ),
      '',
      'TECH STACK',
      ...(result.techStack || []).map(
        (t) => `[${t.category}] ${t.technology} — ${t.rationale}`
      ),
      '',
      'INTEGRATION NOTE',
      result.integrationNote,
    ];
    const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `e2e-brief-${Date.now()}.txt`;
    a.click();
  };

  const phaseColors = [
    { bg: 'rgba(0,194,212,0.1)', color: 'var(--cyan)' },
    { bg: 'rgba(232,160,32,0.1)', color: 'var(--yellow)' },
    { bg: 'rgba(0,179,125,0.1)', color: 'var(--green)' },
  ];
  const gapClass = (g) =>
    g === 'HIGH' ? 'gap-high' : g === 'MED' ? 'gap-med' : 'gap-low';

  return (
    <>
      <style>{css}</style>
      <div className="app">
        <header className="header">
          <div className="header-eyebrow">End-to-End Process Intelligence</div>
          <h1 className="header-title">
            Logistics Automation
            <br />
            <span>Process Advisor</span>
          </h1>
          <p className="header-sub">
            Map your full warehouse process chain, identify automation gaps, and
            receive a phased implementation roadmap.
          </p>
          <div className="header-meta">
            <div className="header-meta-tag">Inbound → Outbound</div>
            <div className="header-meta-tag">7 Process Nodes</div>
            <div className="header-meta-tag">AI-Powered · 2026</div>
          </div>
        </header>

        <div className="steps-bar">
          {[
            [1, 'Operation Context'],
            [2, 'Process Mapping'],
            [3, 'Strategy Output'],
          ].map(([n, label]) => (
            <div
              key={n}
              className={`step-item ${step === n ? 'active' : ''} ${
                step > n ? 'done' : ''
              }`}
              onClick={() => {
                if (n < 3 || result) setStep(n);
              }}
            >
              <div className="step-num">{step > n ? '✓' : n}</div>
              <div className="step-label">{label}</div>
            </div>
          ))}
        </div>

        {step === 1 && (
          <div className="card">
            <div className="card-title">Operation Context</div>
            <div className="context-grid">
              {[
                ['Industry Vertical', 'vertical', VERTICALS],
                ['Site Scale', 'scale', SCALES],
                ['Daily Volume', 'volume', VOLUMES],
              ].map(([label, key, opts]) => (
                <div key={key} className="field">
                  <div className="field-label">{label}</div>
                  <select
                    className="field-input"
                    value={context[key]}
                    onChange={(e) => setCtx(key, e.target.value)}
                  >
                    {opts.map((v) => (
                      <option key={v}>{v}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
            <div className="cta-row" style={{ marginTop: '24px' }}>
              <button className="btn-primary" onClick={() => setStep(2)}>
                Continue → Map Your Processes
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <>
            <div className="card">
              <div className="card-title">Process Pipeline</div>
              <div className="pipeline">
                {PROCESSES.map((p, i) => {
                  const cfg = processes[p.id];
                  return (
                    <div
                      key={p.id}
                      className={`pipe-node level-${cfg.level} ${
                        selected === p.id ? 'selected' : ''
                      }`}
                      onClick={() => setSelected(p.id)}
                    >
                      <div className="pipe-node-inner">
                        <div className="pipe-icon">{p.icon}</div>
                        <div className="pipe-name">{p.name}</div>
                        <div className={`pipe-status ${cfg.level}`}>
                          {levelLabel(cfg.level)}
                        </div>
                        {i < PROCESSES.length - 1 && (
                          <div className="pipe-arrow" />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="legend">
                {[
                  ['var(--red)', 'Manual'],
                  ['var(--yellow)', 'Partial'],
                  ['var(--green)', 'Automated'],
                ].map(([c, l]) => (
                  <div key={l} className="leg-item">
                    <div className="leg-dot" style={{ background: c }} />
                    {l}
                  </div>
                ))}
              </div>
            </div>
            {selected &&
              (() => {
                const p = PROCESSES.find((x) => x.id === selected);
                const cfg = processes[selected];
                return (
                  <div className="card">
                    <div className="process-config">
                      <div className="config-title">
                        {p.icon} {p.name} — {p.desc}
                      </div>
                      <div className="config-grid">
                        <div className="field">
                          <div className="field-label">Automation Level</div>
                          <div className="level-sel">
                            {['none', 'partial', 'full'].map((lv) => (
                              <button
                                key={lv}
                                className={`lev-btn ${lv} ${
                                  cfg.level === lv ? 'active' : ''
                                }`}
                                onClick={() => setProc(selected, 'level', lv)}
                              >
                                {lv === 'none'
                                  ? 'Manual'
                                  : lv === 'partial'
                                  ? 'Partial'
                                  : 'Automated'}
                              </button>
                            ))}
                          </div>
                        </div>
                        <div className="field">
                          <div className="field-label">Pain Intensity</div>
                          <div className="pain-track">
                            <div className="pain-val">
                              {cfg.pain}
                              <span
                                style={{
                                  fontSize: '11px',
                                  color: 'var(--text-muted)',
                                }}
                              >
                                {' '}
                                / 10
                              </span>
                            </div>
                            <input
                              type="range"
                              min={1}
                              max={10}
                              step={1}
                              value={cfg.pain}
                              onChange={(e) =>
                                setProc(selected, 'pain', +e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <div className="field-label">Volume Intensity</div>
                          <div className="level-sel">
                            {['low', 'medium', 'high'].map((lv) => (
                              <button
                                key={lv}
                                className={`lev-btn ${
                                  lv === 'high'
                                    ? 'none'
                                    : lv === 'medium'
                                    ? 'partial'
                                    : 'full'
                                } ${cfg.volume === lv ? 'active' : ''}`}
                                onClick={() => setProc(selected, 'volume', lv)}
                              >
                                {lv.charAt(0).toUpperCase() + lv.slice(1)}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}
            <div className="cta-row">
              <button className="btn-secondary" onClick={() => setStep(1)}>
                ← Back
              </button>
              <button
                className="btn-primary"
                onClick={runAnalysis}
                disabled={loading}
              >
                {loading ? 'Generating Analysis…' : 'Generate E2E Strategy →'}
              </button>
            </div>
            {loading && (
              <div className="loading-wrap">
                <div className="loading-pipeline">
                  {PROCESSES.map((_, i) => (
                    <div key={i} className="load-seg" />
                  ))}
                </div>
                <div className="load-text">
                  Analysing end-to-end process chain…
                </div>
              </div>
            )}
            {error && (
              <div
                style={{
                  textAlign: 'center',
                  color: 'var(--red)',
                  fontFamily: 'var(--font-mono)',
                  fontSize: '11px',
                  marginTop: '20px',
                }}
              >
                {error}
              </div>
            )}
          </>
        )}

        {step === 3 && result && (
          <>
            <div className="results-header">
              <div
                className="metric-tile"
                style={{
                  '--fill': result.e2eScore / 100,
                  '--color': 'var(--cyan)',
                }}
              >
                <div className="metric-key">E2E Maturity</div>
                <div className="metric-val">{result.e2eScore}</div>
                <div className="metric-sub">out of 100</div>
              </div>
              <div
                className="metric-tile"
                style={{
                  '--fill':
                    result.integrationRisk === 'LOW'
                      ? 0.3
                      : result.integrationRisk === 'MEDIUM'
                      ? 0.6
                      : 0.9,
                  '--color':
                    result.integrationRisk === 'LOW'
                      ? 'var(--green)'
                      : result.integrationRisk === 'MEDIUM'
                      ? 'var(--yellow)'
                      : 'var(--red)',
                }}
              >
                <div className="metric-key">Integration Risk</div>
                <div className="metric-val" style={{ fontSize: '20px' }}>
                  {result.integrationRisk}
                </div>
                <div className="metric-sub">system complexity</div>
              </div>
              <div
                className="metric-tile"
                style={{
                  '--fill': Math.min(result.totalROIMonths / 36, 1),
                  '--color': 'var(--green)',
                }}
              >
                <div className="metric-key">ROI Timeline</div>
                <div className="metric-val">{result.totalROIMonths}mo</div>
                <div className="metric-sub">full payback</div>
              </div>
              <div
                className="metric-tile"
                style={{ '--fill': 0.85, '--color': '#c0d4e8' }}
              >
                <div className="metric-key">Annual Gain</div>
                <div className="metric-val" style={{ fontSize: '20px' }}>
                  €{Math.round(result.annualGainEUR / 1000)}k
                </div>
                <div className="metric-sub">est. per year</div>
              </div>
            </div>
            <div className="narrative">
              <p>{result.executiveSummary}</p>
            </div>
            <div className="card">
              <div className="card-title">Implementation Roadmap</div>
              <div className="roadmap">
                {(result.phases || []).map((ph, i) => (
                  <div
                    key={i}
                    className="phase-card"
                    style={{
                      '--phase-bg': phaseColors[i].bg,
                      '--phase-color': phaseColors[i].color,
                    }}
                  >
                    <div className="phase-tag">{ph.phase}</div>
                    <div className="phase-title">{ph.title}</div>
                    <div className="phase-timeline">⏱ {ph.timeline}</div>
                    <div className="phase-items">
                      {(ph.actions || []).map((a, j) => (
                        <div key={j} className="phase-item">
                          {a}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="card">
              <div className="card-title">Process Gap Analysis</div>
              <table className="gap-table">
                <thead>
                  <tr>
                    <th>Process</th>
                    <th>Gap Level</th>
                    <th>Gap Description</th>
                    <th>Quick Win</th>
                  </tr>
                </thead>
                <tbody>
                  {(result.processGaps || []).map((g, i) => (
                    <tr key={i}>
                      <td>
                        <span className="proc-name">
                          {PROCESSES.find(
                            (p) =>
                              p.name === g.process ||
                              p.id === g.process?.toLowerCase()
                          )?.icon || '⚙'}{' '}
                          {g.process}
                        </span>
                      </td>
                      <td>
                        <span className={`gap-badge ${gapClass(g.gapLevel)}`}>
                          {g.gapLevel}
                        </span>
                      </td>
                      <td>{g.gap}</td>
                      <td style={{ color: 'var(--navy)', fontWeight: '600' }}>
                        {g.quickWin}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="card">
              <div className="card-title">Recommended Technology Stack</div>
              <div className="tech-grid">
                {(result.techStack || []).map((t, i) => (
                  <div
                    key={i}
                    className="tech-chip"
                    style={{ animationDelay: `${i * 0.07}s` }}
                  >
                    <div className="tech-cat">{t.category}</div>
                    <div className="tech-name">{t.technology}</div>
                    <div className="tech-note">{t.rationale}</div>
                  </div>
                ))}
              </div>
              {result.integrationNote && (
                <div
                  style={{
                    marginTop: '16px',
                    padding: '14px 16px',
                    background: 'var(--bg)',
                    borderRadius: '4px',
                    borderLeft: '2px solid var(--yellow)',
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: '8px',
                      letterSpacing: '0.12em',
                      textTransform: 'uppercase',
                      color: 'var(--yellow)',
                      marginBottom: '5px',
                    }}
                  >
                    Integration Note
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      color: 'var(--text-dim)',
                      lineHeight: '1.6',
                    }}
                  >
                    {result.integrationNote}
                  </div>
                </div>
              )}
            </div>
            <div className="cta-row">
              <button className="btn-secondary" onClick={() => setStep(2)}>
                ← Back to Mapping
              </button>
              <button className="btn-primary" onClick={exportBrief}>
                ↓ Export Strategy Brief
              </button>
            </div>
          </>
        )}

        <footer className="footer">
          <div className="footer-l">
            E2E Logistics Automation Advisor · Process Intelligence
          </div>
          <div className="footer-l">Powered by Claude AI · 2026</div>
        </footer>
      </div>
    </>
  );
}
